import React from "react";
import { Link } from "react-router-dom";

/**
 * Small consent line for form submit areas.
 * Theme variants:
 *   - light (default): for forms on bone/ink-on-light backgrounds
 *   - dark: for forms on ink/dark backgrounds
 */
export const FormConsent = ({ theme = "light", className = "" }) => {
  const base = theme === "dark" ? "text-bone/50" : "text-char-mute";
  const link = theme === "dark"
    ? "text-bone/75 underline-offset-4 hover:text-ember hover:underline"
    : "text-char underline-offset-4 hover:text-ember hover:underline";
  return (
    <p
      data-testid="form-consent"
      className={`text-[11px] leading-relaxed ${base} ${className}`}
    >
      By submitting, you agree to our{" "}
      <Link to="/privacy" className={link}>Privacy Policy</Link>
      {" "}and{" "}
      <Link to="/terms" className={link}>Terms &amp; Conditions</Link>.
    </p>
  );
};

export default FormConsent;
